var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99996 1.16667C3.78579 1.16667 1.16663 3.78584 1.16663 7.00001C1.16663 10.2142 3.78579 12.8333 6.99996 12.8333C10.2141 12.8333 12.8333 10.2142 12.8333 7.00001C12.8333 3.78584 10.2141 1.16667 6.99996 1.16667ZM6.56246 4.66667C6.56246 4.42751 6.76079 4.22917 6.99996 4.22917C7.23913 4.22917 7.43746 4.42751 7.43746 4.66667V7.58334C7.43746 7.82251 7.23913 8.02084 6.99996 8.02084C6.76079 8.02084 6.56246 7.82251 6.56246 7.58334V4.66667ZM7.53663 9.55501C7.50746 9.63084 7.46663 9.68917 7.41413 9.74751C7.35579 9.80001 7.29163 9.84084 7.22163 9.87001C7.15163 9.89917 7.07579 9.91667 6.99996 9.91667C6.92413 9.91667 6.84829 9.89917 6.77829 9.87001C6.70829 9.84084 6.64413 9.80001 6.58579 9.74751C6.53329 9.68917 6.49246 9.63084 6.46329 9.55501C6.43413 9.48501 6.41663 9.40917 6.41663 9.33334C6.41663 9.25751 6.43413 9.18167 6.46329 9.11167C6.49246 9.04167 6.53329 8.97751 6.58579 8.91917C6.64413 8.86667 6.70829 8.82584 6.77829 8.79667C6.91829 8.73834 7.08163 8.73834 7.22163 8.79667C7.29163 8.82584 7.35579 8.86667 7.41413 8.91917C7.46663 8.97751 7.50746 9.04167 7.53663 9.11167C7.56579 9.18167 7.58329 9.25751 7.58329 9.33334C7.58329 9.40917 7.56579 9.48501 7.53663 9.55501Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.b00f8c0aba0351ac743f71c362e4e8c8.svg";
export { ForwardRef as ReactComponent };